import { render, staticRenderFns } from "./UniversitiesWithListings.vue?vue&type=template&id=78eaf0bb&scoped=true&"
import script from "./UniversitiesWithListings.vue?vue&type=script&lang=js&"
export * from "./UniversitiesWithListings.vue?vue&type=script&lang=js&"
import style0 from "./UniversitiesWithListings.vue?vue&type=style&index=0&id=78eaf0bb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78eaf0bb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
installComponents(component, {VAutocomplete})
